import React, { useState, useEffect } from "react";
import styles from "./TagEditor.module.css";

import { getTags, postTag, removeTagFromUsermedia, putTagOnMedia } from "../../api/Api";

import { Tag } from "../Tag/Tag";
import { useMedia, useMediaUpdate } from "../../contexts/MediaContext";
import ErrorHandler from "../../helpers/ErrorHandler";

export const TagEditor = (props) => {

    // props:
    // 
    // mediaItem - OPTIONAL, object containing media information
    //             If omitted, will use media context instead
    // isEditingTag - state var, if tags are being edited

    // ----------------------------------------------------- STATE AND HOOKS
    const mediaContext = useMedia();
    const mediaItem = props.mediaItem === undefined ? mediaContext : props.mediaItem;

    const setMedia = useMediaUpdate();

    let token = localStorage.getItem("token");

    const [thisObjectTags, setThisObjectTags] = useState(mediaItem.tags);
    const [allTags, setAllTags] = useState([]);

    const [showError, setShowError] = useState(null);

    const tags = (thisObjectTags !== null && thisObjectTags !== undefined) ?  
        thisObjectTags.map((tag, index) =>
            <li key={index} className={styles.tag}>
                <Tag tagItem={tag} deleteButtonClick={handleRemoveTag} isEditingTag={props.isEditingTag} />
            </li>
        ) 
        : 
        null;
    
    useEffect(() => {
        // gets tags on first render
        fetchTags();
    }, [])


    // ----------------------------------------------------- PRE-RENDER

    function addTag(event) {
        //adds tag to backend
        if (event.key === "Enter" && event.target.value !== "") { // if user intentionally sends
            setShowError(null);
            if (event.target.value.length > 50) { // doesn't allow adding of tag more than 50 characters
                setShowError("Body of tag is too long, please try again")
            } else {
                // checks to see if object already has tag
                let objectContains = false;
                if (thisObjectTags !== null && thisObjectTags !== undefined) {
                    thisObjectTags.map((tag) => {
                        if (tag.tagValue === event.target.value) {
                            objectContains = true;
                            setShowError("That tag is already associated with this book.")
                        }
                    });
                }

                // checks to see if any object already has tag
                let allContains = false;
                let tagId = 0;
                allTags.map((tag) => {
                    if (tag.tagValue === event.target.value) {
                        allContains = true;
                        tagId = tag.tagID
                    }
                });

                if (allContains && !objectContains) { // if found tag in allTags, adds it to book in backend
                    addTagToObject(tagId);
                } else if (!allContains) { // entirly new tag, add it to tag table and then to spesific object
                    addTagToTags(event.target.value);
                }

                event.target.value = "";
            }
        }
    }

    function handleRemoveTag(tag) {
        // handles a click to the x button of a tag
        setShowError(null)
        removeTagFromDB(tag.tagID);
    }

    // ---------------------------- FUNCTIONS THAT CONNECT TO BACKEND

    async function fetchTags() {
        // gets all tags
        await getTags(token)
            .then((tags) => {
                setAllTags(tags);
            })
            .catch((error) => {
                console.log("failed to get tags, oh no")
                console.log(error)
                ErrorHandler(error);
            })
    }

    async function addTagToObject(tagID) {
        // adds existing tag to existing media
        await putTagOnMedia(mediaItem.usermediaid, tagID, token)
                .then((media) => {
                    setMedia(media);
                    setThisObjectTags(media.tags);
                })
                .catch((error) => {
                    console.log("failed to add tag to book");
                    console.log(error.message);

                    if (error.message == "Request failed with status: 400") {
                        setShowError("That tag is already associated with this book");
                    }

                    ErrorHandler(error);
                })
    }

    async function addTagToTags(tagValue) {
        // adds new tag to tag table
        await postTag(tagValue, token) // adds a new tag to the tag resource collection
            .then((tag) => {
                addTagToObject(tag.tagID);
                setAllTags([...allTags, tag]); // adds new tag to total tags
            })
            .catch((error) => {
                console.log("failed to add tag to tags");
                console.log(error.message)
                ErrorHandler(error);
            })
    }

    async function removeTagFromDB(tagId) {
        //removes tag from media
        await removeTagFromUsermedia(mediaItem.usermediaid, tagId, token)
                .then(
                    setThisObjectTags([...thisObjectTags.filter(tag => tag.tagID !== tagId)])
                )
                .catch((error) => {
                    console.log("failed to remove tag from database")
                    console.log(error)
                    ErrorHandler(error);
                })
    }

    // ----------------------------------------------------- RENDER

    return (
        <div className={styles.tagContainer}>
            <div className={styles.directTagContainer}>
                <ul className={styles.tagList}>
                    {tags}
                </ul>
                <div>
                    {showError === null ? null : <h5 className={styles.errorMessage}>{showError}</h5>}
                    <input className={styles.tagInput} key="tag input"
                        type="text"
                        autoFocus={false}
                        list='tagSuggestion'
                        placeholder="Enter tag"
                        onKeyUp={event => addTag(event)} />
                    <datalist id="tagSuggestion">
                        {allTags.map((tag, index) => {
                            return (<option key={index} value={tag.tagValue}>{tag.tagValue}</option>)
                        })}
                    </datalist>
                </div>
                
            </div>
        </div>
    );
}